export const NAVIGATE_TO_PROFILE = 'profile';
export const NAVIGATE_TO_CREATE_POST = 'create_post';
export const NAVIGATE_TO_MY_DRAFTS = 'my_drafts';
export const NAVIGATE_TO_PROFILE_SETTINGS = 'settings';
export const LOGOUT = 'logout';



// WEBPACK FOOTER //
// ./app/constants/widget-avatar-actions.js